import * as yup from 'yup';

import { budgetValidationSchema } from '../components/budget-section/AdCampaignBudgetFormModal/budgetAndBidValidationSchema';
import {
  schedulesValidationSchema,
  SchedulesValidationSchemaAttrs,
} from '../components/schedule-section/adCampaignScheduleValidationSchema';

type AdCampaignFormValidationSchemaAttrs = SchedulesValidationSchemaAttrs;

export const adCampaignFormValidationSchema = (options: AdCampaignFormValidationSchemaAttrs) =>
  yup
    .object({
      agreementTermsAndConditions: yup.boolean().required(),
    })
    .concat(budgetValidationSchema.concat(schedulesValidationSchema(options)));
